/**
 * 账户中心左侧导航 — IA 对齐 spikex-ai-web/lib/nav.ts ACCOUNT_NAV
 */

import {
  IconNavUserCircle,
  IconNavShieldCheck,
  IconNavBadgeCheck,
  IconNavSlidersHorizontal,
  IconNavPercent,
  IconNavFolderMinus,
  IconNavInfo,
} from "../globalHeader/navIcons";

function tr(t, key, fallback) {
  if (!t || !key) return fallback;
  const value = t(key);
  return value && value !== key ? value : fallback;
}

export const SECURITY_INNER_KEYS = [
  "email",
  "google-authenticator",
  "mobile",
  "login-password",
  "anti-phishing",
  "security-password",
  "reset-password",
  "reset-verification",
];

export const VERIFY_INNER_KEYS = ["levels", "institutions"];

export const SETTING_INNER_KEYS = [
  "setting",
  "setting-language",
  "setting-currency",
  "notification-setting",
];

/** 主栏目页（PC 顶栏标题） */
export const ACCOUNT_MAIN_SECTION_KEYS = {
  "security-center": {
    labelKey: "nav.profileMenu.security",
    labelFallback: "Security",
    subtitleKey: "account.securitySubtitle",
    subtitleFallback: "Protect your account and manage security settings.",
  },
  email: {
    labelKey: "account.email",
    labelFallback: "Email",
  },
  mobile: {
    labelKey: "mobile.mobile",
    labelFallback: "Mobile",
  },
  "login-password": {
    labelKey: "sign.change",
    labelFallback: "Change Login Password",
  },
  "anti-phishing": {
    labelKey: "account.SetAntiPhishingCode",
    labelFallback: "Anti-Phishing Code",
  },
  verification: {
    labelKey: "account.Authentication",
    labelFallback: "Identity Verification",
    subtitleKey: "account.verificationSubtitle",
    subtitleFallback: "Verify your identity to add fiat-trading permissions and raise limits.",
  },
  levels: {
    labelKey: "account.Authentication",
    labelFallback: "Identity Verification",
    subtitleKey: "account.PleaseNoteThatTheAuthentication",
    subtitleFallback: "Please note that the authentication information cannot be modified once approved — fill it in accurately.",
  },
  setting: {
    labelKey: "nav.profileMenu.preferences",
    labelFallback: "Preferences",
    subtitleKey: "account.preferencesSubtitle",
    subtitleFallback: "Tune how SpikeX looks and what it tells you about.",
  },
  "fee-rate": {
    labelKey: "rate.title",
    labelFallback: "Fee Rate",
    subtitleKey: "rate.subtitle",
    subtitleFallback: "Trading rates and deposit / withdrawal fees across networks and currencies.",
  },
  "spikex-card": {
    labelKey: "spikexCard.title",
    labelFallback: "Spikex Card",
    subtitleKey: "spikexCard.subtitle",
    subtitleFallback: "Your crypto-powered Mastercard — spend anywhere, settle in USD",
  },
  "spikex-card-apply": {
    labelKey: "spikexCard.formTitle",
    labelFallback: "Card Application",
  },
  "spikex-card-recharge": {
    labelKey: "spikexCard.rechargeTitle",
    labelFallback: "Top Up",
  },
  "spikex-card-transactions": {
    labelKey: "spikexCard.transactionsTitle",
    labelFallback: "Transactions",
  },
  api: { labelKey: "account.apiManagement", labelFallback: "API Management" },
  "payment-method": {
    labelKey: "paymentMethod.pageTitle",
    labelFallback: "Withdrawal Payment Method",
    subtitleKey: "paymentMethod.pageSubtitle",
    subtitleFallback: "Saved crypto addresses and fiat accounts you can withdraw to.",
  },
  about: {
    labelKey: "account.about",
    labelFallback: "About",
    subtitleKey: "account.aboutSubtitle",
    subtitleFallback: "Legal documents, community and app downloads.",
  },
};

export function buildAccountNav({ t, getUrl }) {
  const items = [
    {
      id: "overview",
      labelKey: "nav.profileMenu.profile",
      labelFallback: "Profile",
      href: getUrl("/accounts/user/overview"),
      icon: IconNavUserCircle,
      matchKeys: ["overview", "spikex-card", "spikex-card-apply", "spikex-card-recharge", "spikex-card-transactions"],
    },
    {
      id: "security",
      labelKey: "nav.profileMenu.security",
      labelFallback: "Security",
      href: getUrl("/accounts/user/security-center"),
      icon: IconNavShieldCheck,
      matchKeys: ["security-center", ...SECURITY_INNER_KEYS],
    },
    {
      id: "verification",
      labelKey: "nav.profileMenu.verification",
      labelFallback: "Verification",
      href: getUrl("/accounts/user/verification"),
      icon: IconNavBadgeCheck,
      matchKeys: ["verification", ...VERIFY_INNER_KEYS],
    },
    {
      id: "preferences",
      labelKey: "nav.profileMenu.preferences",
      labelFallback: "Preferences",
      href: getUrl("/accounts/user/setting"),
      icon: IconNavSlidersHorizontal,
      matchKeys: SETTING_INNER_KEYS,
    },
    {
      id: "fee-rate",
      labelKey: "nav.profileMenu.feeRate",
      labelFallback: "Fee Rate",
      href: getUrl("/rate"),
      icon: IconNavPercent,
      external: true,
      matchKeys: ["fee-rate"],
    },
    {
      id: "payment",
      labelKey: "nav.accountNav.paymentMethods",
      labelFallback: "Payment Methods",
      href: getUrl("/accounts/user/payment-method"),
      icon: IconNavFolderMinus,
      matchKeys: ["payment-method"],
    },
    {
      id: "about",
      labelKey: "account.about",
      labelFallback: "About",
      href: getUrl("/accounts/user/about"),
      icon: IconNavInfo,
      matchKeys: ["about"],
    },
  ];

  return items.map((item) => ({
    ...item,
    label: tr(t, item.labelKey, item.labelFallback),
  }));
}

export function resolveActiveNavId(navItems, tabKey) {
  for (const item of navItems) {
    if (item.matchKeys?.includes(tabKey)) return item.id;
  }
  return null;
}
